'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _clientLibrary = require('@seneca/client-library');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Typed error for when a course enrollment field failed validation
 * @param {string} field the field that failed validation
 * @param {string} message the validation message
 */


var QueryCoursesParamsNotValidError = function (_ExtendableError) {
  (0, _inherits3.default)(QueryCoursesParamsNotValidError, _ExtendableError);

  function QueryCoursesParamsNotValidError(field, message) {
    (0, _classCallCheck3.default)(this, QueryCoursesParamsNotValidError);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QueryCoursesParamsNotValidError.__proto__ || (0, _getPrototypeOf2.default)(QueryCoursesParamsNotValidError)).call(this, 'Query courses: ' + field + ' failed validation. ' + message));

    _this.field = field;
    return _this;
  }

  return QueryCoursesParamsNotValidError;
}(_clientLibrary.ExtendableError);

exports.default = QueryCoursesParamsNotValidError;